import { render, staticRenderFns } from "./OnlineClasses.vue?vue&type=template&id=77b56ad0&scoped=true"
import script from "./OnlineClasses.vue?vue&type=script&lang=js"
export * from "./OnlineClasses.vue?vue&type=script&lang=js"
import style0 from "./OnlineClasses.vue?vue&type=style&index=0&id=77b56ad0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../ChatGenial-hom-sync/client/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b56ad0",
  null
  
)

export default component.exports